// Guards dialogs and drawers that hold typed work: Escape, the X button and the mask still close
// them, but when something changed the user is asked first.
//
//     mixins: [discardGuard]
//     el-dialog(:before-close="confirmDiscard(() => changedSince(formSnapshot, form))")
//
// Take the snapshot when the dialog opens (`this.formSnapshot = this.snapshotOf(this.form)`).
export const snapshotOf = (value) => (value === undefined ? '' : JSON.stringify(value));

export default {
    methods: {
        // returns a `before-close` handler for el-dialog / el-drawer: closes at once when nothing
        // changed, otherwise asks before throwing the work away. `isDirty` is a function.
        confirmDiscard(isDirty) {
            return (done) => {
                if (!isDirty()) return done();
                this.$confirm(
                    this.$t('Your changes have not been saved.'),
                    this.$t('Discard changes?'),
                    {
                        type: 'warning',
                        confirmButtonText: this.$t('Discard'),
                        cancelButtonText: this.$t('Keep editing'),
                    }
                ).then(() => done()).catch(() => {});
            };
        },
        snapshotOf,
        // true once `value` differs from the snapshot taken on open; without a snapshot (the
        // dialog has not finished opening) nothing counts as changed.
        changedSince(snapshot, value) {
            return snapshot !== undefined && snapshotOf(value) !== snapshot;
        },
    },
};
